import type { NextPage } from 'next';
import { OpenItemType } from '@/types/header.types';
import Link from 'next/link';
import Image from 'next/image';
import styles from './DropdownItem.module.scss';
import { useState } from 'react';

const DropdownItem: NextPage<OpenItemType> = ({ data }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={styles.dropdownTrigger}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link href={data.href} className={styles.navLink}>
        <span>{data.title}</span>
        <Image
          src="/img/header/grayArrow.svg"
          alt=""
          width={16}
          height={16}
          className={`${styles.arrow} ${isHovered ? styles.rotated : ''}`}
        />
      </Link>

      {isHovered && data.subItems && data.subItems.length > 0 && (
        <div className={styles.dropdownMenu}>
          {data.subItems.map((item) => (
            <Link
              key={item.id}
              href={item.href}
              className={styles.dropdownItem}
            >
              {item.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropdownItem;
